/******/ (() => {
  // webpackBootstrap

  // --- Tiered Incentives Progress Bar Logic ---
  function getTieredIncentives(cart) {
    const incentives = [];
    for (let i = 1; i <= 4; i++) {
      const enabled = Shopify.theme_settings[`incentive_${i}_enabled`];
      if (enabled === "no") continue;
      if (
        enabled === "powdered_products_only" &&
        !cart.items.some((item) => {
          const powders = Shopify.theme_settings.tiered_incentives_powdered_products
            .split(",")
            .map((s) => s.trim());
          return powders.includes(item.product_title);
        })
      ) {
        continue;
      }
      incentives.push({
        idx: i,
        amount: Number(Shopify.theme_settings[`incentive_${i}_amount`]),
        progress_bar_text: Shopify.theme_settings[`incentive_${i}_progress_bar_text`],
        dynamic_message: Shopify.theme_settings[`incentive_${i}_dynamic_message`],
      });
    }

    return incentives;
  }

  function getTieredProgressData(cart) {
    const cartTotal = cart.original_total_price / 100;
    const incentives = getTieredIncentives(cart);
    let previousAmount = 0;
    let previousUnlocked = false;
    const progressData = [];

    incentives.forEach((incentive, idx) => {
      const unlocked = cartTotal >= incentive.amount;
      let progress = 0;
      if (idx === 0) {
        progress = Math.min(100, Math.max(0, (cartTotal / incentive.amount) * 100));
      } else {
        if (!previousUnlocked) {
          progress = 0;
        } else if (unlocked) {
          progress = 100;
        } else {
          const range = incentive.amount - previousAmount;
          const progressRaw = cartTotal - previousAmount;
          progress = range > 0 ? Math.min(100, Math.max(0, (progressRaw / range) * 100)) : 0;
        }
      }
      progressData.push({
        ...incentive,
        unlocked,
        progress,
      });
      previousUnlocked = unlocked;
      previousAmount = incentive.amount;
    });

    return progressData;
  }

  function updateTieredProgressBar(cart) {
    const progressData = getTieredProgressData(cart);

    progressData.forEach((incentive, idx) => {
      // Progress bar logic (for all except the last item)
      if (idx < progressData.length - 1) {
        const next = progressData[idx + 1];
        document.querySelectorAll(`#progress-bar-${incentive.idx}`).forEach((progressBar) => {
          progressBar.value = next.progress;
          progressBar.style.setProperty("--progress", `${next.progress}%; -anim-delay: 500ms;`);
        });
      }

      // Bubble logic (for every item, including the last)
      document.querySelectorAll(`#incentive-${incentive.idx} .progress-bar-tick`).forEach((bubble) => {
        if (incentive.unlocked) {
          bubble.classList.add("has-gift");
        } else {
          bubble.classList.remove("has-gift");
        }
      });
    });
  }

  function updateTieredIncentiveMessage(cart) {
    const progressData = getTieredProgressData(cart);
    let message = "";
    let isSuccess = false;
    const cartTotal = cart.original_total_price / 100;
    const EURO_TO_BGN_RATE = 1.95583;

    // Find the first incentive not unlocked
    const next = progressData.find((incentive) => !incentive.unlocked && incentive.amount - cartTotal > 0);
    if (next) {
      const amountRemaining = (next.amount - cartTotal).toFixed(2);

      if (Shopify.theme_settings.show_euro_currency) {
        const amountRemainingBgn = (amountRemaining * EURO_TO_BGN_RATE).toFixed(2);
        message = next.dynamic_message.replace(":amount", amountRemaining + " € / " + amountRemainingBgn + " лв.");
      } else {
        message = next.dynamic_message.replace(":amount", amountRemaining);
      }
    } else {
      // All unlocked, show success message
      message = Shopify.theme_settings.tiered_incentives_success_message;
      isSuccess = true;
    }

    document.querySelectorAll(".cart__price-automatic-discount").forEach((el) => {
      el.textContent = message;
    });
  }

  function removeStalePowderedIncentives(cart) {
    const powders = Shopify.theme_settings.tiered_incentives_powdered_products
      .split(",")
      .map((s) => s.trim());
    const hasPowdered = cart.items.some((item) => powders.includes(item.product_title));
    if (!hasPowdered) {
      document.querySelectorAll('[data-incentive-type="powdered_products"]').forEach((el) => {
        // Remove associated progress bar if it exists
        const idx = el.id.replace("incentive-", "");
        const progressBar = document.getElementById(`progress-bar-${idx}`);
        if (progressBar) progressBar.remove();
        // Remove the incentive bubble
        el.remove();
      });
    }
  }

  function handleTieredProgressBar(cart) {
    updateTieredProgressBar(cart);
    updateTieredIncentiveMessage(cart);
    removeStalePowderedIncentives(cart);
  }

  function checkFreeTShirtEligiblity(cart) {
    const cartOriginalPrice = cart.original_total_price / 100;
    const freeTShirtAmount = Shopify.theme_settings.free_tshirt_amount;
    const freeTShirtVariantId = $(".free-tshirt-container").data("variant-id");
    const shouldEnableFreeTShirtButton = cartOriginalPrice > freeTShirtAmount && !freeTShirtVariantId;
    const freeTShirtButton = $("#free-tshirt-button-cart #free-gift-button");

    if (shouldEnableFreeTShirtButton) {
      freeTShirtButton.prop("disabled", false);
    } else {
      freeTShirtButton.prop("disabled", true);
    }
  }

  function removeFreeTShirtIfIneligible(cart) {
    const cartOriginalPrice = cart.original_total_price / 100;
    const freeTShirtAmount = Shopify.theme_settings.free_tshirt_amount;
    const freeTShirtVariantId = $(".free-tshirt-container").data("variant-id");
    const shouldRemoveFreeTShirtFromCart = cartOriginalPrice < freeTShirtAmount && !!freeTShirtVariantId;

    if (shouldRemoveFreeTShirtFromCart) {
      const updateData = {
        [freeTShirtVariantId]: 0,
      };

      jQuery.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/update.js",
        data: {
          updates: updateData,
        },
        dataType: "json",
        success: function (e) {
          location.reload();
        },
        async: false,
      });
    }
  }

  var __webpack_exports__ = {};

  Shopify.theme.jsCart = {
    init: function ($section) {
      // Add settings from schema to current object
      //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));

      this.$section = $section;

      $(document).on("click", "[data-cart-page-delete]", function (e) {
        e.preventDefault();

        var cartItemKey = $(this).data("cart-item-key").split(":")[0];

        const lineID = $(this).parents("[data-cart-item]").attr("data-line-item");

        Shopify.theme.jsCart.removeFromCart(lineID, cartItemKey);

        return false;
      });

      // Prevent the ajax cart form from being submitted when pressing the "Enter" key
      $("#cart_form").keydown(function (e) {
        if (e.keyCode == 13) {
          e.preventDefault();
          return false;
        }
      });
    },
    removeFromCart: function (lineID, cartItemKey) {
      const $cartItem = Shopify.theme.jsCart.$section.find(`[data-line-item="${lineID}"]`);
      const isFreeItem = $cartItem.is(".free-item");

      $cartItem.css("opacity", "0.5");

      const handleOnlyFreeItemsInCart = () => {
        const updateData = {};
        const group = $(".product_group");
        group.find(".product_group_variants span").each(function () {
          const variant_id = $(this).attr("variant-id");
          if (variant_id != undefined || variant_id != "") {
            updateData[variant_id] = 0;
          }
        });

        jQuery.ajax({
          type: "POST",
          url: window.Shopify.routes.root + "cart/update.js",
          data: {
            updates: updateData,
          },
          dataType: "json",
          success: function (e) {
            localStorage.setItem("hasFreeTshirt", false);
            location.reload();
          },
          async: false, // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
        });
      };

      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + lineID,
        dataType: "json",
        success: function (cart) {
          $cartItem.addClass("animated zoomOut");
          $cartItem.remove();

          if (cart.total_price === 0) {
            handleOnlyFreeItemsInCart();
          }

          Shopify.theme.jsCart.updateView(cart, lineID);

          if (typeof Shopify.theme.jsAjaxCart !== "undefined") {
            Shopify.theme.jsAjaxCart.updateView();
          }

          if (isFreeItem) {
            location.reload();
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          response = response.description;
        },
      });
    },
    updateView: function (cart, lineID) {
      if (cart.item_count > 0) {
        $.ajax({
          dataType: "json",
          async: false,
          cache: false,
          dataType: "html",
          url: "/cart",
          success: function (html) {
            if (lineID !== null) {
              const updatedItems = $(html).find(".cart__item-list .cart__card");
              const currentItems = $(".cart__item-list .cart__card");

              // Checks if BOGO applied and there is a change in the number of line items
              if (updatedItems.length != currentItems.length) {
                const updatedCartList = $(html).find(".cart__item-list");

                // Re-append cart items
                $(".cart__item-list").replaceWith(updatedCartList);
              }

              $(currentItems).each(function (index, element) {
                $(element).attr("data-line-item", index + 1);
                $(element)
                  .find("[data-line-item-key]")
                  .attr("data-line-item-key", index + 1);
              });

              if (Shopify.theme_settings.enable_tiered_incentives) {
                handleTieredProgressBar(cart);
              }

              removeFreeTShirtIfIneligible(cart);
              checkFreeTShirtEligiblity(cart);

              const listOfProductNames = cart.items.map((item) => item.product_title.trim());

              const powderedProducts = Shopify.theme_settings.tiered_incentives_powdered_products
                ?.split(",")
                .map((s) => s.trim());

              // Check if any cart product is exactly a powdered product
              const hasPowderedProduct = listOfProductNames.some((productName) =>
                powderedProducts.includes(productName)
              );

              if (hasPowderedProduct) {
                $("#cart-gift-shaker").removeClass("hidden");
              } else {
                $("#cart-gift-shaker").addClass("hidden");
              }

              cart.items.forEach((cartItem, lineItemId) => {
                const itemTotal = $(html)
                  .find(`[data-variant-id="${cartItem.id}"][data-cart-item="${cartItem.key}"]`)
                  .find(".cart__total")
                  .first();

                const isSubscriptionItem = !!cartItem.selling_plan_allocation?.selling_plan;

                // REPLACE ALL INSTANCES RATHER THAN JUST FIRST
                const itemToReplace = $(
                  `[data-variant-id="${cartItem.id}"][subscription="${isSubscriptionItem}"]`
                ).find(".cart__total");

                $(itemToReplace).replaceWith(itemTotal);

                // Update relative attributes
                $(`[data-variant-id="${cartItem.id}"][subscription="${isSubscriptionItem}"]`).attr(
                  "data-line-item",
                  lineItemId + 1
                );
              });

              const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find(".quantity-input");

              const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find(".cart__price");

              $(`[data-line-item="${lineID}"]`).find(".quantity-input").replaceWith(quantityInput);

              $(`[data-line-item="${lineID}"]`).find(".cart__price").replaceWith(itemPrice);
            }

            const subtotal = $(html).find(".cart__subtotal-container");
            const discounts = $(html).find(".cart__discounts");
            const savings = $(html).find(".cart__total-savings");

            $(".cart__subtotal-container").replaceWith(subtotal);

            if (discounts.length > 0 && $(".cart__discounts").length < 1) {
              $(".cart__subtotal-container").before(discounts);
            } else {
              $(".cart__discounts").replaceWith(discounts);
            }

            if (savings.length > 0 && $(".cart__total-savings").length < 1) {
              $(".cart__subtotal-container").after(savings);
            } else {
              $(".cart__total-savings").replaceWith(savings);
            }

            $('[data-bind="itemCount"]').text(cart.item_count);
          },
          error: function (error) {
            console.log(error, "Failed to update cart view");
          },
        });
      } else {
        $(".cart__empty-cart-message").removeClass("is-hidden");
        $(".cart__form").addClass("is-hidden");
        $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
        $('[data-bind="itemCount"]').text("0");
      }
    },
    unload: function ($section) {
      // Clear event listeners in theme editor
      $("[data-cart-page-delete]").off();
      $("#cart_form").off();
    },
  };

  /******/
})();
